<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->
                <mdb-card-title>
                    <!-- Project Title -->
                    <h2>PROJET JAVA SIMULATEUR DE BESTIOLE</h2>
                    <!-- Project date + duration -->
                    <h4><b>Fin :</b> Juin 2021</h4>
                    <h4><b>Durée :</b> 3 mois</h4>
                </mdb-card-title>
                <!-- Project image -->
                <mdb-card-img class="project-picture" src="assets/bete.png"></mdb-card-img>
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/java.png" />
                                <img class="dot" src="assets/skills/github.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p>Java, Github</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>
                                Dans la cadre de mes cours Java en BTS SIO j'ai un réalisé un simulateur de bestioles avec une interface graphique pour l'utilisateur.
                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>
                                Grâce à ce projet, j'ai pu approfondir mes connaissances en POO JAVA Vous pouvez consulter le projet sur mon github
                                <li><a href="https://github.com/hugo59400/BESTIOLE">Website</a></li>

                            </p>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>

<app-projects></app-projects>